/* Gaxilo Aqua One page system (gx). Safe to load more than once. */
(function () {
  if (window.__gxReady) return;
  window.__gxReady = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function currencyCode() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currencyCode() }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function formatWholeMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currencyCode(),
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(Math.floor(cents / 100));
    } catch (e) {
      return String(Math.floor(cents / 100));
    }
  }

  /* Gallery */
  if (!customElements.get('gx-gallery')) {
    customElements.define('gx-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-slide]'));
        this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-thumb]'));
        this.counter = this.querySelector('[data-counter]');
        this.index = 0;
        if (!this.track || this.slides.length < 2) return;

        var self = this;
        this.thumbs.forEach(function (thumb, i) {
          thumb.addEventListener('click', function () { self.go(i); });
        });
        var prev = this.querySelector('[data-prev]');
        var next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); });
        if (next) next.addEventListener('click', function () { self.go(self.index + 1); });

        var frame;
        this.track.addEventListener('scroll', function () {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(function () { self.sync(); });
        }, { passive: true });

        this.track.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.index + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.index - 1); }
        });
      }

      go(i) {
        var n = this.slides.length;
        if (!n) return;
        i = ((i % n) + n) % n;
        this.track.scrollTo({ left: this.slides[i].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      goToMedia(id) {
        for (var i = 0; i < this.slides.length; i++) {
          if (String(this.slides[i].dataset.mediaId) === String(id)) { this.go(i); return; }
        }
      }

      sync() {
        var width = this.track.clientWidth || 1;
        var i = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / width)));
        if (i === this.index && this.dataset.synced) return;
        this.index = i;
        this.dataset.synced = '1';
        this.thumbs.forEach(function (thumb, t) {
          var on = t === i;
          thumb.setAttribute('aria-current', on ? 'true' : 'false');
          if (on && thumb.parentElement) {
            var strip = thumb.parentElement;
            var left = thumb.offsetLeft - (strip.clientWidth - thumb.clientWidth) / 2;
            strip.scrollTo({ left: Math.max(0, left), behavior: reduceMotion ? 'auto' : 'smooth' });
          }
        });
        if (this.counter) this.counter.textContent = (i + 1) + ' / ' + this.slides.length;
      }
    });
  }

  /* Variant picker */
  if (!customElements.get('gx-variant-picker')) {
    customElements.define('gx-variant-picker', class extends HTMLElement {
      connectedCallback() {
        var data = this.querySelector('[data-variants]');
        this.variants = data ? JSON.parse(data.textContent) : [];
        var self = this;
        this.addEventListener('change', function () { self.onChange(); });
      }

      onChange() {
        var sets = Array.prototype.slice.call(this.querySelectorAll('fieldset'));
        var selected = sets.map(function (fs) {
          var checked = fs.querySelector('input:checked');
          return checked ? checked.value : null;
        });
        sets.forEach(function (fs, i) {
          var out = fs.querySelector('[data-opt-value]');
          if (out) out.textContent = selected[i] || '';
        });
        var match = this.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        }) || null;
        var root = this.closest('gx-product');
        if (root) root.update(match);
      }
    });
  }

  /* Product controller */
  if (!customElements.get('gx-product')) {
    customElements.define('gx-product', class extends HTMLElement {
      connectedCallback() {
        this.sid = this.dataset.section;
        this.initQuantity();
        this.initDelivery();
        this.initSticky();
      }

      submitButton() {
        return this.querySelector('#ProductSubmitButton-' + this.sid);
      }

      update(variant) {
        var strings = window.variantStrings || {};
        var button = this.submitButton();
        var label = button ? button.querySelector('span') : null;
        var form = this.querySelector('form[data-type=add-to-cart-form]');
        var idInput = form ? form.querySelector('[name=id]') : null;
        var sticky = this.querySelector('[data-gx-sticky-btn]');

        if (!variant) {
          if (button) button.setAttribute('disabled', 'disabled');
          if (label) label.textContent = strings.unavailable || 'Unavailable';
          if (sticky) sticky.disabled = true;
          return;
        }

        if (idInput) {
          idInput.value = variant.id;
          idInput.disabled = false;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (button) {
          if (variant.available) {
            button.removeAttribute('disabled');
            if (label) label.textContent = strings.addToCart || 'Add to cart';
          } else {
            button.setAttribute('disabled', 'disabled');
            if (label) label.textContent = strings.soldOut || 'Sold out';
          }
        }
        if (sticky) sticky.disabled = !variant.available;

        this.querySelectorAll('[data-gx-price]').forEach(function (box) {
          var now = box.querySelector('[data-now]');
          var was = box.querySelector('[data-was]');
          var save = box.querySelector('[data-save]');
          var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
          if (now) now.textContent = formatMoney(variant.price);
          if (was) {
            was.hidden = !onSale;
            if (onSale) was.textContent = formatMoney(variant.compare_at_price);
          }
          if (save) {
            save.hidden = !onSale;
            if (onSale) {
              var diff = variant.compare_at_price - variant.price;
              var text = box.dataset.saveText || 'Save';
              save.textContent = box.dataset.saveStyle === 'percent'
                ? text + ' ' + Math.floor((diff * 100) / variant.compare_at_price) + '%'
                : text + ' ' + formatWholeMoney(diff);
            }
          }
        });
        var stickyPrice = this.querySelector('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

        if (this.dataset.updateUrl === 'true' && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }

        if (variant.featured_media) {
          var gallery = this.querySelector('gx-gallery');
          if (gallery && gallery.goToMedia) gallery.goToMedia(variant.featured_media.id);
        }
      }

      initQuantity() {
        this.querySelectorAll('[data-gx-qty]').forEach(function (wrap) {
          var input = wrap.querySelector('input');
          var minus = wrap.querySelector('[data-minus]');
          var plus = wrap.querySelector('[data-plus]');
          if (!input) return;
          function set(value) {
            input.value = Math.max(1, value);
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          if (minus) minus.addEventListener('click', function () { set((parseInt(input.value, 10) || 1) - 1); });
          if (plus) plus.addEventListener('click', function () { set((parseInt(input.value, 10) || 1) + 1); });
        });
      }

      initDelivery() {
        this.querySelectorAll('[data-gx-delivery]').forEach(function (el) {
          var min = parseInt(el.dataset.min, 10) || 7;
          var max = Math.max(min, parseInt(el.dataset.max, 10) || 10);
          var template = el.dataset.template || '';
          var out = el.querySelector('[data-delivery-text]');
          if (!out || template.indexOf('[DATES]') === -1) return;

          function addBusinessDays(n) {
            var d = new Date();
            var added = 0;
            while (added < n) {
              d.setDate(d.getDate() + 1);
              var day = d.getDay();
              if (day !== 0 && day !== 6) added++;
            }
            return d;
          }
          function fmt(d) {
            return d.toLocaleDateString(document.documentElement.lang || 'en-US', { weekday: 'short', month: 'short', day: 'numeric' });
          }

          var parts = template.split('[DATES]');
          var strong = document.createElement('strong');
          strong.textContent = fmt(addBusinessDays(min)) + ' – ' + fmt(addBusinessDays(max));
          out.textContent = '';
          out.appendChild(document.createTextNode(parts[0]));
          out.appendChild(strong);
          out.appendChild(document.createTextNode(parts.slice(1).join('')));
        });
      }

      initSticky() {
        var bar = this.querySelector('[data-gx-sticky]');
        if (!bar) return;
        var self = this;
        var target = this.querySelector('.product-form') || this.submitButton();
        var stickyButton = bar.querySelector('[data-gx-sticky-btn]');
        if (!target || !stickyButton) return;

        stickyButton.addEventListener('click', function () {
          var main = self.submitButton();
          if (main && !main.disabled && main.getAttribute('aria-disabled') !== 'true') {
            main.click();
          } else {
            target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          }
        });

        var ticking = false;
        function refresh() {
          ticking = false;
          var show = target.getBoundingClientRect().bottom < 0;
          if (show === bar.classList.contains('is-visible')) return;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
          document.body.style.paddingBottom = show ? bar.offsetHeight + 'px' : '';
        }
        window.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(refresh);
        }, { passive: true });
        window.addEventListener('resize', refresh);
        refresh();
      }
    });
  }

  /* Flow diagram: run the water only while it is on screen */
  function initFlow(root) {
    (root || document).querySelectorAll('[data-gx-flow]').forEach(function (el) {
      if (el.dataset.gxFlowInit) return;
      el.dataset.gxFlowInit = '1';
      if (reduceMotion || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { el.classList.toggle('is-live', entry.isIntersecting); });
      }, { threshold: 0.2 });
      io.observe(el);
    });
  }

  /* Any [data-gx-atc] link adds the page's product to the cart */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('[data-gx-atc]') : null;
    if (!trigger) return;
    var button = document.querySelector('gx-product .product-form__submit');
    if (button && !button.disabled && button.getAttribute('aria-disabled') !== 'true') {
      e.preventDefault();
      button.click();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initFlow(); });
  } else {
    initFlow();
  }
  document.addEventListener('shopify:section:load', function (e) { initFlow(e.target); });
})();
